import React from "react";
import Input from "form/Inputs/Input";
import useInput from "form/Hooks/user-input";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Container from "Components/Container/Container";
import usePost from "Hooks/usePost";
import { StatusHandler } from "Components/ApiNotification";
import Spinner from "Components/RequestHandler/Spinner";

import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    value: emailInput,
    isValid: emailIsValid,
    HasError: emailHasError,
    inputChangeHandler: emailChangeHandler,
  } = useInput((value) => value.includes("@") && value.trim() !== "");

  const { postData, isLoading, isError, data } = usePost();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!emailIsValid) return;
    const res = await postData("auth/request-password-reset", {
      email: emailInput,
    });

    if (res?.success) {
      navigate("/verify-forgot-password", { state: { email: emailInput } });
    }
  };

  return (
    <main>
      <Container>
        <div className="my-10">
          <h1 className="text-4xl font-medium text-center mys-10 font-title">
            {t("auth.forgotPassword")}
          </h1>
          <StatusHandler error={isError} data={data} />
        </div>

        <form className="w-1/3 mx-auto font-text">
          <Input
            type="email"
            label={t("common.email")}
            value={emailInput}
            onChange={emailChangeHandler}
          />

          <button
            disabled={!emailIsValid || isLoading}
            onClick={handleSubmit}
            className="bg-primary flex items-center justify-center w-full text-center mt-4 text-white px-4 py-2 text-2xl uppercase rounded-md disabled:opacity-50"
          >
            {isLoading ? <Spinner /> : t("auth.verifyEmail")}
          </button>

          <div className="flex mt-4 items-center justify-between gap-x-8">
            <Link className="hover:underline text-primaryDark" to="/login">
              {t("auth.backToLogin", "Back to Login")}
            </Link>
            <Link className="hover:underline text-primaryDark" to="/register">
              {t("auth.createAccount", "Create an account")}
            </Link>
          </div>
        </form>
      </Container>
    </main>
  );
};

export default ForgotPassword;
